/* eslint-disable react/jsx-pascal-case */
'use client';

import {
	Breadcrumb, Stack, Text,
} from '@chakra-ui/react';

import { AppRoutes } from '@/constants/route';
import { ContentContainer, ContentWrapper } from '@/modules/shared/presentation';
import { FAQ } from '@/modules/static/presentation/components/FAQ/FAQ';
import type { FAQItemViewModel } from '@/modules/static/view-model';

type FAQTopicScreenProps = {
	faqs:  FAQItemViewModel[]
	topic: string
};

export const FAQTopicScreen = ({ faqs, topic }: FAQTopicScreenProps) => {
	return (
		<ContentContainer bg="white">
			<ContentWrapper as={Stack} gap="xl">
				<Breadcrumb.Root>
					<Breadcrumb.List>
						<Breadcrumb.Item>
							<Breadcrumb.Link color="primary.100" href={AppRoutes.static.faq} textStyle="body">FAQ</Breadcrumb.Link>
						</Breadcrumb.Item>
						<Breadcrumb.Separator />
						<Breadcrumb.Item>
							<Breadcrumb.CurrentLink color="primary.100" textStyle="body">
								{topic}
							</Breadcrumb.CurrentLink>
						</Breadcrumb.Item>
					</Breadcrumb.List>
				</Breadcrumb.Root>
				<Stack gap="md">
					<Text textStyle="h1">
						{topic}
					</Text>
					<FAQ faqs={faqs} />
				</Stack>
			</ContentWrapper>
		</ContentContainer>
	);
};
